import { JSX } from 'solid-js';

interface GlowCardProps {
  class?: string;
  children: JSX.Element;
}

export default function GlowCard(props: GlowCardProps) {
  return (
    <div class={`mp-glow-card ${props.class || ''}`.trim()}>
      {props.children}
    </div>
  );
}

